__turbopack_context__.v({
  "footer": "ModularizedPlanCards-module-scss-module__xQIopW__footer",
  "form": "ModularizedPlanCards-module-scss-module__xQIopW__form",
  "line-break": "ModularizedPlanCards-module-scss-module__xQIopW__line-break",
  "text-align_center": "ModularizedPlanCards-module-scss-module__xQIopW__text-align_center",
  "wrapper": "ModularizedPlanCards-module-scss-module__xQIopW__wrapper",
});
